import { Component, ViewChild } from '@angular/core';
import { Certificate, Certificate_data, Certificates } from 'src/app/models/certificates';
import { Form_Data } from 'src/app/models/util.models';
import { PromiseResult, ErrorModel, ServerError } from '../../../../models/PromiseResult';
import { DoctorsService } from 'src/app/services/doctors.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng';
import { FileUpload } from 'primeng/fileupload';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-certificates',
    templateUrl: './certificates.component.html',
    styleUrls: ['./certificates.component.css']
})
export class CertificatesComponent {
    @ViewChild('fileUpload') fileUpload!: FileUpload;
    loading: boolean = false;
    certificates: Certificates[] = [];
    certificate: Certificate = new Certificate();
    certificate_data: Certificate_data = new Certificate_data();
    showAddCertificateDialog: boolean = false;
    showDeleteDialog: boolean = false;
    response: PromiseResult;
    remove_response: PromiseResult;
    table_response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;
    remove_error: ErrorModel;
    remove_serverError: ServerError;
    remove_posting: boolean;
    file = null;
    certificate_id: string;
    base64url: string;
    //   newCertificate: any = { name: '', expiryDate: null, file: null };

    Document_data = [
        { id: 0, name: 'Enhanced DBS Certificate', data: [] },
        { id: 1, name: 'GMC Certificate', data: [] },
        { id: 2, name: 'Professional Indemnity Insurance', data: [] }
    ];
    availableCertificates: any[] = [];

    constructor(
        private readonly doctorService: DoctorsService,
        private readonly messageService: MessageService,
        private cdr: ChangeDetectorRef
    ) {

    }

    async ngOnInit() {
        await this.getOwnedCertificates();

    }
    openAddCertificateDialog() {
        this.certificate = new Certificate();
        this.serverError = null;
        this.getAvailableCertificates(); // Refresh available list before showing
        this.showAddCertificateDialog = true;
    }

    closeAddCertificateDialog() {
        this.showAddCertificateDialog = false;
        if (this.fileUpload) {
            this.fileUpload.clear(); // Clear uploaded files
        }
    }

    getAvailableCertificates() {
        const uploadedNames = this.certificates.map(c => c.document_name);
        this.availableCertificates = this.Document_data.filter(doc => !uploadedNames.includes(doc.name));
    }

    uploadFiles(file: File[]) {

        if (file[0].size > 5033165) {
            // this.fileu=true;
            this.file = null;
        }
        else if (file[0].size < 5033165) {
            // this.fileu=false;
            this.file = file[0];
        }

        else this.file = null;
    }

    clearfile() {
        this.file = null;
    }


    async getOwnedCertificates() {
        await this.doctorService.GetDoctorOwnedCertificates().toPromise().then(async result => {
            this.table_response = result;
            if (this.table_response.success) {
                let temp: Certificates[] = [];

                for (let row of result.data.rows) {
                    temp.push({
                        id: row.id,
                        document_name: row.document_name,
                        document_url: row.document_url,
                        expires_on: row.expires_on,
                        doctor_user_guid: row.doctor_user_guid,
                        verified_by: row.verified_by == null ? 'Not verified' : row.verified_by,
                    });
                }

                this.certificates = temp;
                this.getAvailableCertificates(); // <-- Add this
            }
        });
    }

    getFileExtension(mimeType: string): string {
        switch (mimeType) {
            case 'application/pdf':
                return 'pdf';
            case 'image/jpeg':
                return 'jpg';
            case 'image/png':
                return 'png';
            default:
                return 'pdf'; // fallback
        }
    }


    async DownloadCertificate(certificate_id: string, doctor_user_guid: string) {
        try {
            const result = await this.doctorService.DownloadDoctorCertificate(certificate_id, doctor_user_guid).toPromise();
            this.table_response = result;

            if (this.table_response.success) {
                const base64Data = this.table_response.data.base64;
                const fileType = this.table_response.data.file_type || 'application/pdf'; // e.g., 'application/pdf', 'image/png', etc.
                const fileExtension = this.getFileExtension(fileType);
                const fileName = `certificate.${fileExtension}`;

                const downloadLink = document.createElement('a');
                downloadLink.href = `data:${fileType};base64,${base64Data}`;
                downloadLink.download = fileName;
                downloadLink.click();
            }
        } catch (error) {
            console.error('Error downloading certificate:', error);
        }
    }


    openDeleteDialog(id: string) {
        this.showDeleteDialog = true;
        this.certificate_id = id;
    }

    closeDeleteDialog() {
        this.showDeleteDialog = false;
    }

    async onRemoveCertificate() {
        try {
            const result = await this.doctorService.RemoveDoctorCertificate(this.certificate_id).toPromise();

            this.remove_response = result;
            if (this.remove_response.success) {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Certificate Deleted Successfully",
                });
                this.showDeleteDialog = false;

                await this.getOwnedCertificates();
                this.cdr.detectChanges(); // Force Angular to update the UI
            } else {
                this.remove_posting = false;
                this.remove_error = result.error;
            }
        } catch (error: any) {
            this.remove_serverError = error.error;
            this.remove_response.success = false;
            this.remove_posting = false;
        }
    }


    async addCertificate() {
        this.loading = true;
        this.certificate_data.api_data.name = this.certificate.name;
        this.certificate_data.api_data.expiryDate = this.certificate.expiryDate;
        this.certificate_data.api_data.file = this.file;
        this.certificate_data.form_data = new Form_Data();
        this.certificate_data.form_data.form_data = this.certificate_data.form_data.create_form_data(this.certificate_data.api_data, new FormData(), "");
        await this.doctorService.CreateDoctorCertificate(this.certificate_data.form_data.form_data).toPromise().then(async result => {
            this.response = result;
            if (this.response.success) {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Certificate Added Successfully",
                });
                this.showAddCertificateDialog = false;
                this.posting = false;
                await this.getOwnedCertificates();
                // this.resetForm();
            }
            else if (!this.response.success) {
                this.posting = false;
                this.error = result.error;
            }

        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        });
        this.loading = false;
    }



}
